import React from "react";
import styled from "styled-components";
import { MenuItems } from "constants/menu-items";
import MenuItem from "./MenuItem";

const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 0 1rem;
`;

const MenuWrapper = styled.div`
  height: fit-content;
  border: 1px solid black;
  border-radius: 2rem;
  display: flex;
  flex-direction: column;
  padding: 0.75rem 0.5rem;
`;

const Menu = () => {
  return (
    <MenuContainer>
      <MenuWrapper>
        {MenuItems.map((value, index) => (
          <MenuItem key={`menuitem-${index}`} {...value} />
        ))}
      </MenuWrapper>
    </MenuContainer>
  );
};

export default Menu;
